import { SearchForMedicalPaOrdersFromPostgresParams } from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";

/**
 * Generates an array of Postgres search payloads for pages 0 through batchNumber,
 * used to restore previously loaded pages on re-mount. Also stamps the active
 * server-side sort onto each page payload so the restored data is fetched in the
 * same order the user last saw.
 *
 * @param filterPayload - Base Postgres search parameters
 * @param batchNumber - The last batch (page) index that was previously fetched
 * @param sortByField - Canonical backend field name to sort by (empty string for no sort)
 * @param sortAscending - Sort direction; true for ascending, false for descending
 * @returns Array of payloads, one per page from 0 to batchNumber
 */
export const recursivelyGeneratePayloadForInitialFetch = (
  filterPayload: SearchForMedicalPaOrdersFromPostgresParams,
  batchNumber: number,
  sortByField: string,
  sortAscending: boolean,
): SearchForMedicalPaOrdersFromPostgresParams[] => {
  const arraysFromBatchNumber = Array.from(
    { length: batchNumber + 1 },
    (_, index) => index,
  );
  return arraysFromBatchNumber.map((index) => ({
    ...filterPayload,
    page: index,
    ...(sortByField
      ? {
          sort_by: sortByField,
          sort_dir: sortAscending ? "asc" : "desc",
        }
      : {}),
  }));
};
